import React from "react";

class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false };
    }

    static getDerivedStateFromError() {
        return { hasError: true };
    }

    componentDidCatch(error, info) {
        // Optionally log error to a service
        // console.error(error, info);
    }

    render() {
        if (this.state.hasError) {
            return <div style={{ padding: 24, textAlign: "center" }}>خطایی رخ داد. لطفاً صفحه را رفرش کنید.</div>;
        }
        return this.props.children;
    }
}

export default ErrorBoundary;


